// extracted by mini-css-extract-plugin
export default {"wrapper":"SuccessMessage_wrapper__uNd9Z","button":"SuccessMessage_button__xdOnK"};